export function communicationsList({ communications }) {
  return communications.communicationsList;
}

export function communicationsSortBy({ communications }) {
  return communications.communicationsList.sortBy;
}
